// extracted by mini-css-extract-plugin
module.exports = {"base":"8px","wrapper":"elementsWrapper_wrapper__MspkF"};